import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography
} from '@material-ui/core';
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon
} from '@material-ui/icons';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import api from '../../../services/api';
import { AMODULO_PARTNER } from 'consts';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';

/* Schema de validação do formulário de login */
const schema = {
  email: {
    presence: {
      allowEmpty: false,
      message: 'É obrigatório!'
    },
    email: { message: 'Não é válido!' }
  },
  senha: {
    presence: {
      allowEmpty: false,
      message: 'É obrigatória!'
    },
    length: {
      maximum: 30,
      message: 'Máximo de 30 caracteres!'
    }
  }
};

/* Schema de validação do formulário de recuperação de senha */
const schemaRecuperacao = {
  email: {
    presence: {
      allowEmpty: false,
      message: 'É obrigatório!'
    },
    email: { message: 'Não é válido!' }
  }
};

/* Estilos da tela de login do módulo Partner */
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100vh'
  },
  grid: { height: '100%' },
  quoteContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  quote: {
    backgroundColor: theme.palette.grey[200],
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/images/authpartner.png)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: 600
  },
  quoteText: {
    color: theme.palette.common.white,
    fontWeight: 300
  },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingBottom: theme.spacing(6)
    }
  },
  title: { marginTop: theme.spacing(3) },
  subtitle: { marginTop: theme.spacing(1) },
  textField: { marginTop: theme.spacing(2) },
  signInButton: { margin: theme.spacing(3, 0, 1, 0) },
  forgotPassword: {
    marginTop: theme.spacing(1),
    cursor: 'pointer',
    color: theme.palette.primary.main,
    textAlign: 'right'
  },
  message: { marginTop: theme.spacing(2) }
}));

/* Tela de login do portal do módulo Partner (fornecedor) */
const Login = (props) => {
  const { history } = props;
  const classes = useStyles();

  const [message, setMessage] = useState({
    message: '',
    type: ''
  });

  const [showPassword, setShowPassword] = useState(false);

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      email: '',
      senha: ''
    },
    touched: {},
    errors: {}
  });

  const [openForgotDialog, setOpenForgotDialog] = useState(false);

  const [forgotState, setForgotState] = useState({
    email: '',
    touched: false,
    errors: {}
  });

  // revalida o formulário sempre que os valores dos campos mudam
  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState((prev) => ({
      ...prev,
      isValid: !errors,
      errors: errors || {}
    }));
  }, [formState.values]);

  // atualiza os valores e marca os campos do formulário de login como tocados
  const handleChange = (event) => {
    event.persist();

    setFormState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        [event.target.name]: event.target.value
      },
      touched: {
        ...prev.touched,
        [event.target.name]: true
      }
    }));
  };

  // atualiza o e-mail informado no diálogo de recuperação de senha
  const handleForgotChange = (event) => {
    const { value } = event.target;

    setForgotState((prev) => ({
      ...prev,
      email: value,
      touched: true,
      errors: {}
    }));
  };

  // verifica se um campo do formulário de login foi tocado e possui erro
  const hasError = (field) => {
    return !!(formState.touched[field] && formState.errors[field]);
  };

  // verifica se o e-mail do diálogo de recuperação de senha possui erro
  const hasForgotError = () => {
    return !!(forgotState.touched && forgotState.errors.email);
  };

  // valida as credenciais do partner na API e salva a sessão
  const validaUsuario = async () => {
    try {
      const data = {
        email: formState.values.email,
        senha: formState.values.senha
      };

      console.log('Vai validar:', data);

      const response = await api.post('/partner/loginpartner', data);
      console.log('Retorno do login do Partner:', response.data);

      const usuario = response.data?.usuario;
      console.log('O que está em usuário:' + JSON.stringify(usuario))

      if (!usuario || !usuario.id) {
        setMessage({
          message: 'Resposta de login inválida!',
          type: 'error'
        });

        return null;
      }

      sessionStorage.setItem('codUser', String(usuario.id));
      sessionStorage.setItem('usuarioPartner', usuario.nomeusuario || '');
      sessionStorage.setItem('emailPartner', usuario.email || formState.values.email);
      sessionStorage.setItem('modulo', String(AMODULO_PARTNER));
      sessionStorage.setItem('partnerPortal', 'partner');
      sessionStorage.setItem('idPartner', usuario.codFornecedor)
      sessionStorage.setItem('partnerUser', usuario.nomeUsuario || '');

      setMessage({
        message: 'Logando...',
        type: 'success'
      });

      console.log('codUser salvo:', sessionStorage.getItem('codUser'));
      console.log('usuario salvo:', sessionStorage.getItem('usuario'));
      console.log('partnerPortal salvo:', sessionStorage.getItem('partnerPortal'));

      return response;
    } catch (error) {
      console.error('Erro no login do Partner:', error);

      if (error.message === 'Network Error') {
        setMessage({
          message: 'O serviço da API não respondeu!',
          type: 'error'
        });
      } else {
        setMessage({
          message: error.response?.data?.message || 'E-mail ou senha inválidos!',
          type: 'error'
        });
      }

      return null;
    }
  };

  // trata o submit do formulário de login e redireciona o partner ao autenticar
  const handleSignIn = async (event) => {
    event.preventDefault();

    const response = await validaUsuario();

    if (!response) {
      return;
    }

    history.push('/partner/agendaescalafornecedor');
  };

  // fecha o diálogo de recuperação de senha
  const closeForgotPassword = () => {
    setOpenForgotDialog(false);
  };

  // valida e envia a solicitação de recuperação de senha
  const handleForgotPasswordSubmit = async () => {
    const errors = validate(
      { email: forgotState.email },
      schemaRecuperacao
    );

    if (errors) {
      setForgotState((prev) => ({
        ...prev,
        errors,
        touched: true
      }));

      return;
    }

    try {
      await api.post('/recuperarsenha', {
        email: forgotState.email
      });

      setOpenForgotDialog(false);

      setMessage({
        message: 'Se o e-mail estiver cadastrado, as instruções de recuperação foram enviadas!',
        type: 'success'
      });
    } catch (error) {
      setOpenForgotDialog(false);

      setMessage({
        message: 'Erro ao solicitar a recuperação de senha!',
        type: 'error'
      });
    }
  };

  return (
    <div className={classes.root}>
      <Grid
        className={classes.grid}
        container
      >
        <Grid
          className={classes.quoteContainer}
          item
          lg={5}
        >
          <div className={classes.quote}>
            <div className={classes.quoteInner}>
              <Typography
                className={classes.quoteText}
                variant="h3"
              ></Typography>
            </div>
          </div>
        </Grid>

        <Grid
          className={classes.content}
          item
          lg={7}
          xs={12}
        >
          <div className={classes.content}>
            <div className={classes.contentBody}>
              <form
                className={classes.form}
                onSubmit={handleSignIn}
              >
                <Typography
                  className={classes.title}
                  variant="h2"
                >
                  Login
                </Typography>

                <Typography
                  className={classes.subtitle}
                  color="textSecondary"
                  gutterBottom
                >
                  Informe seu e-mail e senha para acessar o sistema
                </Typography>

                <TextField
                  className={classes.textField}
                  error={hasError('email')}
                  fullWidth
                  helperText={hasError('email') ? formState.errors.email[0] : null}
                  label="E-mail"
                  name="email"
                  onChange={handleChange}
                  type="email"
                  value={formState.values.email || ''}
                  variant="outlined"
                  autoComplete="email"
                />

                <TextField
                  className={classes.textField}
                  error={hasError('senha')}
                  fullWidth
                  helperText={hasError('senha') ? formState.errors.senha[0] : null}
                  label="Senha"
                  name="senha"
                  onChange={handleChange}
                  type={showPassword ? 'text' : 'password'}
                  value={formState.values.senha || ''}
                  variant="outlined"
                  autoComplete="current-password"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />

                <Button
                  className={classes.signInButton}
                  color="primary"
                  disabled={!formState.isValid}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Entrar
                </Button>

                <Typography
                  className={classes.message}
                  color={message.type === 'error' ? 'error' : 'primary'}
                >
                  {message.message}
                </Typography>
              </form>
            </div>
          </div>
        </Grid>
      </Grid>

      <Dialog
        open={openForgotDialog}
        onClose={closeForgotPassword}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Recuperação de senha</DialogTitle>

        <DialogContent>
          <Typography
            variant="body2"
            color="textSecondary"
            gutterBottom
          >
            Informe seu e-mail para receber as instruções de recuperação.
          </Typography>

          <TextField
            autoFocus
            margin="dense"
            label="E-mail"
            type="email"
            fullWidth
            variant="outlined"
            value={forgotState.email}
            onChange={handleForgotChange}
            error={hasForgotError()}
            helperText={hasForgotError() ? forgotState.errors.email[0] : null}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={closeForgotPassword}>
            Cancelar
          </Button>

          <Button
            color="primary"
            variant="contained"
            onClick={handleForgotPasswordSubmit}
          >
            Enviar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

Login.propTypes = {
  history: PropTypes.object
};

export default withRouter(Login);